<template>
  <el-drawer title="选择物资" append-to-body :visible.sync="drawer" destroy-on-close :wrapperClosable="false" custom-class="widthSpecial">
    <div class="p-18" v-loading="loading">
      <treeTransfer
        v-if="!loading"
        ref="treeTransfer"
        :title="['可选择物资', '已选择物资']"
        :defaultProps="{
          children: 'child',
          label: 'name',
        }"
        :data="data"
      ></treeTransfer>
    </div>
    <FixedTwoButton activeClass="widthSpecial">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import treeTransfer from '@/components/Tree-transfer'
import { materialsCategoryStockList } from '@/api/workflow'
import { cloneDeep } from 'lodash'
export default {
  components: { treeTransfer },
  inject: ['indexThis', 'addThis'],
  props: {
    selectedData: {
      type: Array,
      default: () => [],
    },
    queryData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      drawer: false,
      data: [],
      loading: false,
    }
  },
  watch: {
    drawer(val) {
      if (!val) return
      this.getList()
    },
  },
  methods: {
    async getList() {
      this.loading = true
      Promise.all([this.materialsCategoryStockList()])
        .then(res => {
          if (!res) return
          this.data = res[0].map(item => ({
            id: item.categoryId,
            label: item.categoryName,
            name: item.categoryName,
            chargeObject: 2,
            level: 1,
            child: item.categoryMaterial.map(ele => ({
              level: 2,
              chargeObject: 2,
              id: ele.materialId,
              label: ele.materialName,
              name: `${ele.materialName}（库存：${ele.stock}${this.dictType('materialUnit', ele.materialUnit)}）`,
              materialUnit: ele.materialUnit,
              number: '',
              materialCategoryId: item.categoryId,
              materialCategoryName: item.categoryName,
            })),
          }))
          const setSelect = data => {
            for (let node of data) {
              if (node.child && node.child.length) {
                // 递归处理子节点
                setSelect(node.child) // 检查所有子节点是否都选中

                const allChildrenSelected = node.child.every(child => child.selected) // 更新当前节点的 selected 状态

                node.selected = allChildrenSelected
              } else {
                // 叶子节点，直接使用其 selected 状态
                node.selected = this.selectedData.some(item => item.id === node.id)
              }
            }
          }
          setSelect(this.data)
        })
        .finally(err => {
          this.loading = false
        })
    },

    async materialsCategoryStockList() {
      const { data } = await materialsCategoryStockList(this.queryData)
      return data
    },

    // 提交
    submitForm() {
      this.addThis.selectedData = cloneDeep(this.$refs.treeTransfer.checkedData)
      const data = this.addThis.selectedData.reduce((acc, item) => {
        const category = acc.find(cat => cat.materialCategoryId === item.materialCategoryId)
        if (category) {
          category.materialList.push(item)
        } else {
          acc.push({
            materialCategoryId: item.materialCategoryId,
            materialCategoryName: item.materialCategoryName,
            materialList: [item],
          })
        }
        return acc
      }, [])
      this.updateData(this.addThis.addForm.selectedMaterialList, data)

      this.drawer = false
    },

    updateData(a, b) {
      // 创建一个临时对象来存储 b 中的所有 materialCategoryId
      const bCategories = new Map()
      b.forEach(bItem => {
        bCategories.set(bItem.materialCategoryId, bItem)
      })

      // 遍历 a 中的每个元素
      for (let i = a.length - 1; i >= 0; i--) {
        const aItem = a[i]
        const bItem = bCategories.get(aItem.materialCategoryId)

        if (bItem) {
          // 如果 a 中的元素在 b 中存在
          const bMaterialIds = new Set(bItem.materialList.map(material => material.id))
          // 遍历 a 中该元素的 materialList
          for (let j = aItem.materialList.length - 1; j >= 0; j--) {
            const aMaterial = aItem.materialList[j]
            if (!bMaterialIds.has(aMaterial.id)) {
              // 如果 a 中的 material 在 b 中不存在，则删除
              aItem.materialList.splice(j, 1)
            }
          }

          // 如果 a 中的 materialList 为空，则删除整个 a 中的元素
          if (aItem.materialList.length === 0) {
            a.splice(i, 1)
          }
        } else {
          // 如果 a 中的元素在 b 中不存在，则删除
          a.splice(i, 1)
        }
      }

      // 遍历 b 中的每个元素，添加到 a 中
      b.forEach(bItem => {
        const aItemIndex = a.findIndex(aItem => aItem.materialCategoryId === bItem.materialCategoryId)
        if (aItemIndex !== -1) {
          // 如果找到相同的 materialCategoryId
          const aItem = a[aItemIndex]
          bItem.materialList.forEach(bMaterial => {
            const aMaterialIndex = aItem.materialList.findIndex(aMaterial => aMaterial.id === bMaterial.id)
            if (aMaterialIndex === -1) {
              // 如果在 a 中没有找到相同的 id，则添加
              aItem.materialList.push(bMaterial)
            }
          })
        } else {
          // 如果没有找到相同的 materialCategoryId，则添加整个对象
          a.push(bItem)
        }
      })
    },

    // 重置
    resetForm() {
      if (!this.data) return
      this.$refs.treeTransfer.resetForm()
    },
  },
}
</script>

<style lang="less" scoped>
.p-18 {
  height: 300px;
  padding: 18px 24px;
}
</style>
